import { Component } from '@angular/core';

@Component({
    selector: 'app-backdrop',
    templateUrl: './backdrop.component.html',
    styleUrl: './backdrop.component.scss'
})
export class BackdropComponent {}
